import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { IdCard, Save } from "lucide-react";

const FIELDS = [
  ["specialty", "Specialty", "e.g. Soft game & kitchen strategy"],
  ["experience", "Experience", "e.g. 10+ years coaching, 4.5 rated player"],
  ["facility", "Home Facility", "e.g. Bullpen Court A"],
  ["location", "Location", "e.g. Port Charlotte, FL"],
];

export default function LoungeProfileForm() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/coach/lounge-profile").then(({ data }) => setForm(data)).catch(() => setForm(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/coach/lounge-profile", {
        specialty: form.specialty, experience: form.experience,
        facility: form.facility, location: form.location, bio: form.bio,
      });
      toast.success("Your Coaches Lounge card is updated");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
    finally { setSaving(false); }
  };

  if (form === null || form === false) return null;

  const input = "w-full bg-pb-elevated border border-pb-border px-3 py-2.5 text-white placeholder-zinc-600 focus:outline-none focus:border-pb-red text-sm";

  return (
    <div className="bg-pb-surface border border-pb-border p-5 mb-8" data-testid="lounge-profile-form">
      <div className="flex items-center gap-2 mb-1">
        <IdCard className="w-5 h-5 text-pb-red" />
        <span className="font-display font-bold text-xl uppercase">My Coaches Lounge Card</span>
      </div>
      <p className="text-xs text-zinc-500 mb-4">This is what members see about you in the Coaches Lounge. Your profile photo comes from your Player Profile avatar.</p>
      <div className="grid sm:grid-cols-2 gap-3 mb-3">
        {FIELDS.map(([k, label, ph]) => (
          <div key={k}>
            <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-1.5">{label}</label>
            <input data-testid={`lounge-field-${k}`} value={form[k] || ""} placeholder={ph}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })} className={input} />
          </div>
        ))}
      </div>
      <label className="block text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-1.5">About Me / Coaching Philosophy</label>
      <textarea data-testid="lounge-field-bio" value={form.bio || ""} rows={3}
        placeholder="Tell members what to expect in your sessions…"
        onChange={(e) => setForm({ ...form, bio: e.target.value })}
        className={`${input} resize-none`} />
      <button data-testid="lounge-profile-save" onClick={save} disabled={saving}
        className="mt-3 flex items-center gap-2 bg-pb-red text-black font-bold uppercase tracking-widest px-5 py-2.5 hover:bg-[#BEF264] active:scale-95 transition-all disabled:opacity-50">
        <Save className="w-4 h-4" /> {saving ? "Saving…" : "Save Lounge Card"}
      </button>
    </div>
  );
}
